import { useEffect, useState } from "react";
import { jobService } from "../../../../services/job-service";

function CanChatPage() {
    const [applications, setApplications] = useState([]);
    const [drafts, setDrafts] = useState({});
    const [message, setMessage] = useState("");

    useEffect(() => {
        loadApplications();
    }, []);

    const loadApplications = () => {
        jobService.myApplications()
            .then((data) => setApplications(data.applications || []))
            .catch((error) => setMessage(error.message));
    };

    const send = async (application) => {
        const text = (drafts[application.id] || "").trim();
        if (!text) return;
        try {
            await jobService.sendApplicationMessage(application.id, text);
            setDrafts({ ...drafts, [application.id]: "" });
            loadApplications();
        } catch (error) {
            setMessage(error.message);
        }
    };

    return (
        <div className="twm-right-section-panel site-bg-gray">
            <div className="panel panel-default">
                <div className="panel-heading wt-panel-heading p-a20">
                    <h4 className="panel-tittle m-a0">Messages</h4>
                </div>
                <div className="panel-body wt-panel-body p-a20">
                    {message && <div className="alert alert-info">{message}</div>}
                    {applications.length === 0 ? <div>No application messages yet.</div> : applications.map((application) => (
                        <div className="panel panel-default m-b20" key={application.id}>
                            <div className="panel-heading wt-panel-heading p-a20"><h5 className="m-a0">{application.title} - {application.company_name || "Company"}</h5></div>
                            <div className="panel-body p-a20">
                                {(application.messages || []).length === 0 ? <div>No messages yet.</div> : application.messages.map((item) => (
                                    <div className="dashboard-messages-box" key={item.id}>
                                        <div className="dashboard-message-area"><h5>{item.sender_name || item.sender_role}<span>{new Date(item.created_at).toLocaleString()}</span></h5><p>{item.message}</p></div>
                                    </div>
                                ))}
                                <textarea className="form-control m-b10" rows={3} value={drafts[application.id] || ""} onChange={(event) => setDrafts({ ...drafts, [application.id]: event.target.value })} placeholder="Write a reply to employer..." />
                                <button className="site-button" type="button" onClick={() => send(application)}>Send Reply</button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default CanChatPage;
